import { Fragment, useVisibilityController } from '@frontend/react';
import { Card, Icon, Text, XStack } from '@frontend/web-react';
import type { ClassName } from '@frontend/web-utils';
import { concatClasses } from '@frontend/web-utils';
import { UpdateSecureNoteModal } from '@frontend/web/components/DomainSpecific/Tasks/UpdateSecureNoteModal';
import { useRetrieveSecureNoteContentQuery } from '@frontend/web/hooks';

export type TaskChatSecureNoteCardProps = {
  className?: ClassName;
  isActive: boolean;
  secureNoteId: string;
  taskId: string;
  title: string;
};
export const TaskChatSecureNoteCard = ({
  className,
  isActive,
  secureNoteId,
  taskId,
  title,
}: TaskChatSecureNoteCardProps) => {
  const { isError: isSecureNoteError, isLoading: isSecureNoteLoading } =
    useRetrieveSecureNoteContentQuery(secureNoteId);
  const [isSecureNoteCardModalOpen, { close: closeSecureNoteModal, open: openSecureNoteModal }] =
    useVisibilityController();
  const isCardDisabled = !isActive || isSecureNoteLoading || isSecureNoteError;
  return (
    <Fragment>
      <Card
        className={concatClasses('px-lg py-md gap-x-md rounded-lg bg-surfaceSecondary', className)}
        disabled={isCardDisabled}
        onClick={openSecureNoteModal}
      >
        {/* Title */}
        <XStack alignItems="center" justifyContent="between">
          <XStack gapX="sm">
            <Icon color={!isCardDisabled ? 'primary' : 'tertiary'} name="IconLock" />
            <Text type={!isCardDisabled ? 'h5' : 'p-sm'}>
              {isActive ? '' : 'Deleted'} {title}
            </Text>
          </XStack>
          {!isCardDisabled ? <Icon color="primary" name="IconArrowRight" /> : null}
        </XStack>
        {/* Disclaimer */}
        {!isCardDisabled ? (
          <Text color="tertiary">
            We keep your sensitive info safe and sound, using top-notch encryption and strict access rules – only our
            trained copilots get a peek.
          </Text>
        ) : null}
      </Card>
      {!isCardDisabled ? (
        <UpdateSecureNoteModal
          isOpen={isSecureNoteCardModalOpen}
          onClose={closeSecureNoteModal}
          secureNoteId={secureNoteId}
          taskId={taskId}
          title={title}
        />
      ) : null}
    </Fragment>
  );
};
